import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import useAppFunctionalityConfig from 'hooks/useAppFunctionalityConfig';

// project import
import { isAudienceLink, preserveAudienceLink } from "utils/audienceSafety";
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, user } = useAuth();
    const { isAudienceMode } = useAppFunctionalityConfig();
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        if (!isLoggedIn) {
            navigate(preserveAudienceLink(isAudienceLink(location.search) ? '/anonymous-login' : 'login', location.search), { replace: true });
        }
    }, [isLoggedIn, location.search, navigate]);

    const audience = isAudienceMode || user?.authType === 'anonymous' || isAudienceLink(location.search);
    if (audience && !isLoggedIn) return null;
    if (audience && location.pathname !== '/map-page' && !location.pathname.startsWith('/map-page/')) {
        return <Navigate to={preserveAudienceLink('/map-page', location.search)} replace />;
    }
    return children;
};

export default AuthGuard;
